import ConversationAPI from '../../api/conversations';
import types from '../mutation-types';

export const state = {
  inboxes: {},
  labels: {},
  teams: {},
  all: 0,
  mentions: 0,
  participating: 0,
  unattended: 0,
  customFilters: {},
};

const normalizeCounts = counts => {
  return Object.entries(counts || {}).reduce((result, [id, count]) => {
    const parsedCount = Number(count);
    if (Number.isFinite(parsedCount) && parsedCount > 0) {
      result[String(id)] = parsedCount;
    }

    return result;
  }, {});
};

const normalizeCount = count => {
  const parsedCount = Number(count);
  return Number.isFinite(parsedCount) && parsedCount > 0 ? parsedCount : 0;
};

export const getters = {
  getInboxUnreadCount: $state => inboxId => {
    return $state.inboxes[String(inboxId)] || 0;
  },
  getLabelUnreadCount: $state => labelId => {
    return $state.labels[String(labelId)] || 0;
  },
  getTeamUnreadCount: $state => teamId => {
    return $state.teams[String(teamId)] || 0;
  },
  getInboxUnreadCounts($state) {
    return $state.inboxes;
  },
  getLabelUnreadCounts($state) {
    return $state.labels;
  },
  getTeamUnreadCounts($state) {
    return $state.teams;
  },
  getAllUnreadCount($state) {
    return $state.all;
  },
  getMentionsUnreadCount($state) {
    return $state.mentions;
  },
  getParticipatingUnreadCount($state) {
    return $state.participating;
  },
  getUnattendedUnreadCount($state) {
    return $state.unattended;
  },
  getCustomFilterUnreadCount: $state => filterId => {
    return $state.customFilters[String(filterId)] || 0;
  },
};

export const actions = {
  get: async function getUnreadCounts({ commit }) {
    try {
      const response = await ConversationAPI.getUnreadCounts();
      commit(types.SET_CONVERSATION_UNREAD_COUNTS, response.data.payload);
    } catch (error) {
      // Ignore errors so the sidebar can continue rendering without badges.
    }
  },
  clear({ commit }) {
    commit(types.SET_CONVERSATION_UNREAD_COUNTS, {});
  },
};

export const mutations = {
  [types.SET_CONVERSATION_UNREAD_COUNTS]($state, payload = {}) {
    $state.inboxes = normalizeCounts(payload.inboxes);
    $state.labels = normalizeCounts(payload.labels);
    $state.teams = normalizeCounts(payload.teams);
    $state.all = normalizeCount(payload.all);
    $state.mentions = normalizeCount(payload.mentions);
    $state.participating = normalizeCount(payload.participating);
    $state.unattended = normalizeCount(payload.unattended);
    $state.customFilters = normalizeCounts(payload.custom_filters);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
